
import React from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import PeptideHero from './components/PeptideHero';
import TreatmentOptions from './components/TreatmentOptions';
import BenefitsSection from './components/BenefitsSection';
import ProcessSection from './components/ProcessSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';

const PeptideTherapy: React.FC = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <main>
        <PeptideHero />
        <TreatmentOptions />
        <BenefitsSection />
        <ProcessSection />
        <PricingSection />
        <TestimonialsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default PeptideTherapy;
